// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__XGlf6","container-divide":"index_container-divide___xxwg"};